import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { TextInput } from 'components/Common/Inputs/TextInput';

const editRequired = value => !value || !value.replace(/\s/g, '') || value.replace(/\s/g, '').length < 5;

class AccountNumberChangeModal extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    id: PropTypes.number,
    accountNumber: PropTypes.string
  };

  static defaultProps = {
    accountNumber: '',
    id: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      newAccountNumber: '',
      confirmAccountNumber: ''
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, isShown } = this.props;
    if (!isShown && prevProps.isShown) {
      reset();
    }
  }

  handleCancel(e) {
    const { onCancel } = this.props;
    onCancel();
  }

  handleSubmit(event) {
    const { onConfirm, id, accountNumber } = this.props;
    const { newAccountNumber, confirmAccountNumber } = this.state;
    const updatedData = { id, newNumber: newAccountNumber, confirmNewNumber: confirmAccountNumber };

    const charRanges = [
      '\u00a9',
      '\u00ae',
      '[\u2000-\u3300]',
      '\ud83c[\ud000-\udfff]',
      '\ud83d[\ud000-\udfff]',
      '\ud83e[\ud000-\udfff]'
    ];
    const charRegEx = new RegExp(charRanges.join('|'), 'g');

    event.preventDefault();

    if (!newAccountNumber.replace(/\s/g, '') || newAccountNumber.replace(/\s/g, '').length < 3 || newAccountNumber.replace(/\s/g, '').length > 50) {
      toastr.error('', 'Please provide an Account Number between 3 and 50 characters long.');
      return;
    }

    if (charRegEx.test(newAccountNumber)) {
      toastr.error('', 'Account Number contains invalid characters.');
      return;
    }

    if ((accountNumber && newAccountNumber && newAccountNumber.replace(/\s/g, '') === accountNumber.replace(/\s/g, ''))) {
      toastr.error('', 'The new Account Number cannot be same as the current Account Number.');
      return;
    }

    if ((!newAccountNumber || !confirmAccountNumber || !newAccountNumber.replace(/\s/g, '') || newAccountNumber.replace(/\s/g, '').length < 3 || newAccountNumber !== confirmAccountNumber)) {
      toastr.error('', 'The Account Numbers entered do not match.');
      return;
    }

    onConfirm(updatedData);
  }

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  render() {
    const { isShown, accountNumber } = this.props;
    const {
      newAccountNumber,
      confirmAccountNumber
    } = this.state;

    return (
      <ModalWrapper
        modalSize="account-number-change-modal"
        headerClose={ false }
        isOpen={ isShown }
        title="Change Account Number"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ this.handleCancel }
        onConfirm={ this.handleSubmit }
        formId="accountNumberChangeForm"
      >
        <div>
          { /* eslint-disable-next-line */ }
          <form className="form" id="accountNumberChangeForm" name="accountNumberChangeForm" onSubmit={ this.handleSubmit }>
            <div className="form-group">
              <div className="col-12">
                <p>
                  Please provide new Account Number for Account <span style={ { fontWeight: 'bold' } }>{ accountNumber }</span>
                </p>
              </div>
            </div>

            <div className="form-group">
              <div className="col-4">
                <label htmlFor="newAccountNumber" className="form-label m-2">New Account Number</label>
              </div>
              <div className="col-8">
                <Field
                  id="newAccountNumber"
                  name="newAccountNumber"
                  component={ TextInput }
                  className="form-input m-2"
                  placeholder="Enter new account number"
                  required
                  value={ newAccountNumber }
                  validate={ editRequired }
                  onChange={ this.onDataInputChange }
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-4">
                <label htmlFor="confirmAccountNumber" className="form-label m-2">Confirm Account Number</label>
              </div>
              <div className="col-8">
                <Field
                  id="confirmAccountNumber"
                  name="confirmAccountNumber"
                  component={ TextInput }
                  className="form-input m-2"
                  placeholder="Confirm new account number"
                  required
                  value={ confirmAccountNumber }
                  validate={ editRequired }
                  onChange={ this.onDataInputChange }
                />
              </div>
            </div>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'accountNumberChangeForm'
})(AccountNumberChangeModal));
